const loginDetails = (state = null, action) => {
  if (action.type === "SET_LOGIN_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_LOGIN_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default loginDetails;
